import React, { useState } from "react";
import './sidebar.css';
import { useNavigate } from 'react-router-dom'
import { Image_Url } from '../../constants/imageUrl/ImageUrl'
import Cookies from "js-cookie";
import { decode } from "base-64";
import { useSelector, useDispatch } from "react-redux";
import { toggleSidebar, settingtoggleSidebar, rewardtoggleSidebar, managementtoggleSidebar } from "../../actions/SidebarAction";
import { pageTrainingAction, searchTrainingAction } from "../../actions/trainingAction";
import { searchFaqAction, pageFaqAction } from "../../actions/faqAction";
import { categoryAction, pgmpageAction, retailersearchCriteriaAction, searchCriteriaAction } from "../../actions/pgmlistAction";
import { searchQueryAction, pageQueryAction } from "../../actions/queryAction";
import { trainersearchAction, trainerpageAction } from "../../actions/trainerAction";
import { dataTypeAction } from "../../actions/trainingAction";
import { notificationsearchAction, notificationpageAction } from "../../actions/notificationAction";
import { is2w, is3w } from "../../common/isLogin";
import { role } from "../../constants/constant";
import { searchUniqueIdGenerationAction } from "../../actions/uniqueIdGenerationAction";
import { setSelectedAPSAction } from "../../actions/targetAchievementAction";        


const Sidebar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch()


  const { toggler } = useSelector((state) => state.sidebarToggler);
  const settingtoggler = useSelector((state) => state.settingsidebarToggler.toggler);
  const rewardgtoggler = useSelector((state) => state.rewardsidebarToggler.toggler);
  const managementtoggler = useSelector((state) => state?.managementsidebarToggler?.toggler);
  const permissions = decode(Cookies.get('permissions'));
  const Role = decode(Cookies.get('role'));
  const UserName = decode(Cookies.get('username'));
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(toggler);
  



  const traningsubmenu1 = () => {
    dispatch(toggleSidebar(true));
    dispatch(settingtoggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    navigate('/viewtrainee');
    var seardata = {
      criteria: "",
      value: "",
    };
    // For Traning Page
    dispatch(pageTrainingAction(1));
    dispatch(dataTypeAction("upcoming"));
    dispatch(searchTrainingAction(seardata));
  }
  const traningsubmenu2 = () => {
    dispatch(toggleSidebar(true));
    dispatch(settingtoggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    navigate('/traningattendee');
  }
  const traningsubmenu3 = () => {
    dispatch(toggleSidebar(false));
    dispatch(settingtoggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    navigate('/pgmlist');
    var seardata = {
      criteria: "",
      value: "",
    };
    // For PGM LIST Page
    dispatch(pgmpageAction(1));
    dispatch(categoryAction("all"));
    dispatch(searchCriteriaAction(seardata));
  }
  const pgmRetailer = () => {
    dispatch(toggleSidebar(false));
    dispatch(settingtoggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    navigate('/retailerList');
    var seardata = {
      criteria: "",
      value: "",
    };
    // For PGM LIST Page
    dispatch(pgmpageAction(1));
    dispatch(categoryAction("all"));
    dispatch(retailersearchCriteriaAction(seardata));
  }
  const PgmlistThreeWheeler = () => {
    dispatch(toggleSidebar(false));
    dispatch(settingtoggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    navigate('/3w/pgmlist');
    var seardata = {
      criteria: "",
      value: "",
    };
    // For PGM LIST Page
    dispatch(pgmpageAction(1));
    dispatch(categoryAction("all"));
    dispatch(searchCriteriaAction(seardata));
  }
  const onrewardclick = () => {
    dispatch(toggleSidebar(false));
    dispatch(settingtoggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    navigate('/rewards');
  }
  const onsupportclick = () => {
    dispatch(toggleSidebar(false));
    dispatch(settingtoggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    navigate('/query');
    var seardata = {
      criteria: "",
      value: "",
    };
    // For SUPPORT Page
    dispatch(pageQueryAction(1));
    dispatch(searchQueryAction(seardata));
  }
  const onSupportThreeWheeler = () => {
    dispatch(toggleSidebar(false));
    dispatch(settingtoggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    navigate('/3w/support/query');
    var seardata = {
      criteria: "",
      value: "",
    };
    // For SUPPORT Page
    dispatch(pageQueryAction(1));
    dispatch(searchQueryAction(seardata));
  }
  const ontrainerclick = () => {
    dispatch(toggleSidebar(false));
    dispatch(settingtoggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    navigate('/trainerlist');
    var seardata = {
      criteria: "",
      value: "",
    };
    // For TRAINER Page
    dispatch(trainerpageAction(1));
    dispatch(trainersearchAction(seardata));
  }
  const onnotificationclick = () => {
    dispatch(toggleSidebar(false));
    dispatch(settingtoggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    navigate('/notification');
    var seardata = {
      criteria: "",
      value: "",
    };
    // For NOTIFICATION Page
    dispatch(notificationpageAction(1));
    dispatch(notificationsearchAction(seardata));
  }
  const onbannerclick = () => {
    dispatch(toggleSidebar(false));
    dispatch(settingtoggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    navigate('/banners');
  }
  const onmsrclick = () => {
    dispatch(toggleSidebar(false));
    dispatch(settingtoggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    navigate('/msr');
  }
  const ondsrclick = () => {
    dispatch(toggleSidebar(false));
    dispatch(settingtoggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    navigate('/dsr');
  }
  const onbeatclick = () => {
    dispatch(toggleSidebar(false));
    dispatch(settingtoggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    navigate('/beatmanagement');
  }

  const onDbtRuleManagementclick = () => {
    dispatch(toggleSidebar(false));
    dispatch(settingtoggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    navigate('/dbtrulemanagement');
  }

  const onPincodeMasterListclick = () => {
    dispatch(toggleSidebar(false));
    dispatch(settingtoggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    navigate('/pincodemasterlist');
  }

const onTargetVSAchievementListclick = () => {
  const aps = "";
  const apiData = [];
  const count = 0;
  const page = 1;

  dispatch(toggleSidebar(false));
  dispatch(settingtoggleSidebar(false));
  dispatch(rewardtoggleSidebar(false));
  dispatch(setSelectedAPSAction(aps, apiData, count, page));

  navigate('/planvsactual');
};


  const onuniqueclick = () => {
    dispatch(toggleSidebar(false));
    dispatch(settingtoggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    var seardata = {
      fromDate: "",
      toDate: "",
      value: ""
    };
    navigate('/uniqueidgenerationlist');
    dispatch(searchUniqueIdGenerationAction(seardata));
  }
  const onProductTrainingclick = () => {
    dispatch(toggleSidebar(false));
    dispatch(settingtoggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    navigate('/training/tutorialtroubleshooting');
  }
  const on2wProductTrainingclick = () => {
    dispatch(toggleSidebar(false));
    dispatch(settingtoggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    navigate('/2w/training/list');
  }
  const onReferralclick = () => {
    dispatch(toggleSidebar(false));
    dispatch(settingtoggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    navigate('/3w/referral');
  }
  const onReportClick = () => {
    dispatch(toggleSidebar(false));
    dispatch(settingtoggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    navigate('/reportgeneration');
  }
  const onfaqclick = () => {
    dispatch(toggleSidebar(false));
    dispatch(settingtoggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    navigate('/faq');
    var seardata = {
      criteria: "",
      value: "",
    };
    // For FAQ Page
    dispatch(pageFaqAction(1));
    dispatch(searchFaqAction(seardata));
  }
  const handleSubMenuToggle = () => {
    //setIsSubMenuOpen(!);
    dispatch(toggleSidebar(!toggler));
  };
  const handlesettingSubMenu = () => {
    dispatch(settingtoggleSidebar(!settingtoggler))
    dispatch(rewardtoggleSidebar(false));
    dispatch(toggleSidebar(false));
    dispatch(managementtoggleSidebar(false));
  }
  const HandleManagementSubMenu = () => {
    dispatch(managementtoggleSidebar(!managementtoggler));
    dispatch(settingtoggleSidebar(false))
    dispatch(rewardtoggleSidebar(false));
    dispatch(toggleSidebar(false));
  }
  const handlerewardSubMenu = () => {
    dispatch(rewardtoggleSidebar(!rewardgtoggler))
    dispatch(settingtoggleSidebar(false))
    dispatch(toggleSidebar(false));
    dispatch(managementtoggleSidebar(false));
  }
  const onsettingclick = () => {
    dispatch(toggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    navigate('/setting/changepassword');
  }
  const onDbtConfigurationClick = () => {
    dispatch(toggleSidebar(false));
    dispatch(rewardtoggleSidebar(false));
    dispatch(managementtoggleSidebar(false));
    navigate('/setting/dbtconfiguration');
  }
  const onRoleManagementClick = () => {
    dispatch(toggleSidebar(false));
    navigate('/rolemanagement');
  }
  const onUserMangmentClick = () => {
    dispatch(toggleSidebar(false));
    navigate('/user');
  }
  const onIncentivemappingclick = () => {
    dispatch(toggleSidebar(false));
    navigate('/rewardredeem');
  }
  const onRedemptionlimitclick = () => {
    dispatch(toggleSidebar(false));
    navigate('/redemptionlimit');
  }
  const onScanlimitclick = () => {
    dispatch(toggleSidebar(false));
    navigate('/scanlimit');
  }
  const on2wReferralclick = () => {
    dispatch(toggleSidebar(false));
    navigate('/refferal2w');
  }


  return (
    <div className="SidebarConatiner">
      <div className="sidebarProfileHeader">
        <div className="ProfileConatiner">
          <img
            className="ProfileContainerImage"
            src={Image_Url.TVSLOGO}
            alt="Profiles"
            loading="lazy"
          />
        </div>
        <div className="sidebarUserInfo">
          <div className="sidebarAvatarWrapper">
            <img
              className="sidebarAvatar"
              src={Image_Url.TVSADMIN1}
              alt="ProfilesInfo"
            />
          </div>
          <div className="sidebarUserDetails">
            <span className="sidebarUserName">{String(UserName)?.toLocaleUpperCase()?.replace("_", " ")}</span>
            <span className="sidebarUserRole">{String(Role)?.replace("_", " ")}</span>
          </div>
        </div>
      </div>
      <div className="sidebarHeaderDivider"></div>
      {permissions.includes("pgm_registration_approval") && is2w() ?
        <span onClick={traningsubmenu3} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (window.location.pathname === '/pgmlist' ? 'active' : '')} >
            <img
              className="sideimagePng"
              src={Image_Url.PGM_LIST}
              alt="ProfilesInfo"
            />
            <span>PGM List</span>
          </div>
        </span> : ""}
      {permissions.includes("pgm_registration_approval") && is2w() ?
        <span onClick={pgmRetailer} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (window.location.pathname === '/retailerList' ? 'active' : '')} >
            <img
              className="sideimagePng"
              src={Image_Url.PGM_LIST}
              alt="ProfilesInfo"
            />
            <span>Retailer List</span>
          </div>
        </span> : ""}
      {permissions.includes("pgm_registration_approval") && is3w() ?
        <span onClick={PgmlistThreeWheeler} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (window.location.pathname === '/3w/pgmlist' ? 'active' : '')} >
            <img
              className="sideimage"
              src={Image_Url.PGMLIST}
              alt="ProfilesInfo"
            />
            <span>PGM List</span>
          </div>
        </span> : ""}
      {/* {permissions.includes("Reward") === true ?
        <a onClick={onrewardclick} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (window.location.pathname === '/rewards' ? 'active' : '')}>
            <img
              className="sideimage"
              src={Image_Url.REWARD}
              alt="ProfilesInfo"
            />
            <span>Reward Catalogue</span>

          </div>
        </a> : ""} */}
      {permissions.includes("support_access") && is2w() ?
        <span onClick={onsupportclick} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (window.location.pathname === '/query' ? 'active' : '')}>

            <img
              className="sideimage"
              src={Image_Url.QUERY}
              alt="ProfilesInfo"
            />
            <span>Support</span>
          </div>
        </span> : ""}
      {permissions.includes("support_access") && is3w() ?
        <span onClick={onSupportThreeWheeler} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (window.location.pathname === '/3w/support/query' ? 'active' : '')}>

            <img
              className="sideimage"
              src={Image_Url.QUERY}
              alt="ProfilesInfo"
            />
            <span>Support</span>
          </div>
        </span> : ""}
      {/* {permissions.includes("Support") === true ?
        <a
          onClick={onfaqclick}
          className="anchor_hyperlink">
          <div className={'SideBarbox ' + (window.location.pathname === '/faq' ? 'active' : '')}>
            <img
              className="sideimage"
              src={Image_Url.FAQ}
              alt="ProfilesInfo"
            />
            <span>FAQ</span>
          </div>
        </a>
        : ""} */}
      {/* {permissions.includes("Training") ?
        <a onClick={handleSubMenuToggle} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (isSubMenuOpen || window.location.pathname === '/viewtrainee' || window.location.pathname === '/traningattendee' || window.location.pathname === '/sendinvites' ? 'active' : '')} >
            <img
              className="sideimage"
              src={Image_Url.CREATETRAINING}
              alt="ProfilesInfo"
            />
            <span>Training</span>
          </div>
        </a> : ""} */}
      {/* {toggler && (
        <ul>
          {permissions.includes("Training") ?
            <a onClick={traningsubmenu1} className="anchor_hyperlink">
              <div className={'SideBarbox ' + (window.location.pathname === '/viewtrainee' ? 'active' : '')} >
                <img
                  className="sideimage"
                  src={Image_Url.CREATETRAINING}
                  alt="ProfilesInfo"
                />
                <span className="manage_training_text">Manage Training</span>
              </div>
            </a> : ""}

          {permissions.includes("Training") ?
            <a onClick={traningsubmenu2} className="anchor_hyperlink">
              <div className={'SideBarbox ' + (window.location.pathname === '/traningattendee' ? 'active' : '')}>
                <img
                  className="sideimage"
                  src={Image_Url.TRAINING_ICON}
                  alt="ProfilesInfo"
                />
                <span className="manage_training_text">Training Attendee</span>
              </div>
            </a> : ""}
          {permissions.includes("Training") ?
            <a onClick={() => { navigate('/sendinvites') }} className="anchor_hyperlink">
              <div className={'SideBarbox ' + (window.location.pathname === '/sendinvites' ? 'active' : '')}>
                <img
                  className="sideimage"
                  src={Image_Url.SEND_INVITE_ICON}
                  alt="ProfilesInfo"
                />
                <span className="manage_training_text">Send Invite</span>
              </div>
            </a> : ""}
        </ul>
      )} */}
      {/* {permissions.includes("Training") ?
        <a onClick={ontrainerclick} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (window.location.pathname === '/trainerlist' ? 'active' : '')}>
            <img
              className="sideimage"
              src={Image_Url.TRAINING_ICON}
              alt="ProfilesInfo"
            />
            <span>Trainer</span>
          </div>
        </a> : ""} */}
      {permissions.includes("redemption_limit") && is2w() || permissions.includes("incentive_mapping") && is2w() ?
        <span onClick={handlerewardSubMenu} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (isSubMenuOpen || window.location.pathname === '/rewardredeem' || window.location.pathname === '/redemptionlimit' ? 'active' : '')} >
            <img
              className="sideimage"
              src={Image_Url.REWARD}
              alt="ProfilesInfo"
            />
            <span>Reward</span>
          </div>
        </span> : ""}
      {rewardgtoggler && (
        <ul>
          {permissions.includes("incentive_mapping") && is2w() ?
            <span onClick={onIncentivemappingclick} className="anchor_hyperlink">
              <div className={'SideBarbox ' + (window.location.pathname === '/rewardredeem' ? 'active' : '')} >
                <img
                  className="sideimage"
                  src={Image_Url.REWARD}
                  alt="ProfilesInfo"
                />
                <span className="manage_training_text">Reward mapping</span>
              </div>
            </span> : ""}
        </ul>
      )}
      {rewardgtoggler && (
        <ul>
          {permissions.includes("redemption_limit") && is2w() ?
            <span onClick={onRedemptionlimitclick} className="anchor_hyperlink">
              <div className={'SideBarbox ' + (window.location.pathname === '/redemptionlimit' ? 'active' : '')} >
                <img
                  className="sideimage"
                  src={Image_Url.REWARD}
                  alt="ProfilesInfo"
                />
                <span className="manage_training_text">Redemption Limit</span>
              </div>
            </span> : ""}
        </ul>
      )}
      {rewardgtoggler && (
        <ul>
          {permissions.includes("redemption_limit") && is2w() ?
            <span onClick={onScanlimitclick} className="anchor_hyperlink">
              <div className={'SideBarbox ' + (window.location.pathname === '/scanlimit' ? 'active' : '')} >
                <img
                  className="sideimage"
                  src={Image_Url.REWARD}
                  alt="ProfilesInfo"
                />
                <span className="manage_training_text">Scan Limit</span>
              </div>
            </span> : ""}
        </ul>
      )}
      {rewardgtoggler && (
        <ul>
          {permissions.includes("redemption_limit") && is2w() ?
            <span onClick={on2wReferralclick} className="anchor_hyperlink">
              <div className={'SideBarbox ' + (window.location.pathname === '/refferal2w' ? 'active' : '')} >
                <img
                  className="sideimage"
                  src={Image_Url.REWARD}
                  alt="ProfilesInfo"
                />
                <span className="manage_training_text">Referral</span>
              </div>
            </span> : ""}
        </ul>
      )}
      {permissions.includes("generate_unique_id") && is2w() ?
        <span onClick={onuniqueclick} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (window.location.pathname === '/uniqueidgenerationlist' ? 'active' : '')}>
            <img
              className="sideimage"
              src={Image_Url.SEND_INVITE_ICON}
              alt="ProfilesInfo"
            />
            <span>Unique Id</span>
          </div>
        </span> : ""}
      {permissions.includes("schedule_notifications") ?
        <span onClick={onnotificationclick} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (window.location.pathname === '/notification' ? 'active' : '')}>
            <img
              className="sideimage"
              src={Image_Url.NOTIFICATION}
              alt="ProfilesInfo"
            />
            <span>Notification</span>
          </div>
        </span>
        : ""}

      {Role.toLowerCase().trim() === role.superAdmin || Role.toLocaleLowerCase().trim() === role.superAdmin3w ?
        <span onClick={onbannerclick} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (window.location.pathname === '/banners' ? 'active' : '')}>
            <img
              className="sideimage"
              src={Image_Url.BANNER}
              alt="ProfilesInfo"
            />
            <span>Banners</span>
          </div>
        </span> : ""}
      {permissions.includes("view_reports") && is2w() ?
        <span onClick={onReportClick} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (window.location.pathname === '/reportgeneration' ? 'active' : '')}>
            <img
              className="sideimage"
              src={Image_Url.REPORT}
              alt="ProfilesInfo"
            />
            <span>Report</span>
          </div>
        </span> : ""}
      {Role.toLowerCase().trim() === role.superAdmin || Role.toLocaleLowerCase().trim() === role.superAdmin3w ?
        <span onClick={HandleManagementSubMenu} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (isSubMenuOpen || window.location.pathname === '/rolemanagement' ? 'active' : '')} >
            <img
              className="sideimage"
              src={Image_Url.ROLEUSER}
              alt="ProfilesInfo"
            />
            <span>Roles & Users</span>
          </div>
        </span> : ""}
      {managementtoggler && (
        <ul>
          {Role.toLowerCase().trim() === role.superAdmin || Role.toLocaleLowerCase().trim() === role.superAdmin3w ?
            <span onClick={onRoleManagementClick} className="anchor_hyperlink">
              <div className={'SideBarbox ' + (window.location.pathname === '/rolemanagement' ? 'active' : '')} >
                <img
                  className="sideimage"
                  src={Image_Url.ROLE}
                  alt="ProfilesInfo"
                />
                <span className="manage_training_text">Role Management</span>
              </div>
            </span> : ""}
          {Role.toLowerCase().trim() === role.superAdmin || Role.toLocaleLowerCase().trim() === role.superAdmin3w ?

            <span onClick={onUserMangmentClick} className="anchor_hyperlink">
              <div className={'SideBarbox ' + (window.location.pathname === '/user' ? 'active' : '')} >
                <img
                  className="sideimage"
                  src={Image_Url.USERMANAGEMENT}
                  alt="ProfilesInfo"
                />
                <span className="manage_training_text">User Management</span>
              </div>
            </span> : ""}
        </ul>
      )}
      {permissions.toLocaleLowerCase().includes("can_access_dsr") && is2w() ? (
        <span onClick={ondsrclick} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (window.location.pathname === '/dsr' ? 'active' : '')}>
            <img
              className="sideimagePng"
              src={Image_Url.DSR_ICON}
              alt="ProfilesInfo"
            />
            <span>DSR</span>
          </div>
        </span>
      ) : ""}

      {permissions.includes("can_access_msr") && is2w() ?
        <span onClick={onmsrclick} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (window.location.pathname === '/msr' ? 'active' : '')}>
            <img
              className="sideimagePng"
              src={Image_Url.MSR_ICON}
              alt="ProfilesInfo"
            />
            <span>MSR</span>
          </div>
        </span> : ""}

      {permissions.includes("upload_beat_plan") && is2w() ?
        <span onClick={onbeatclick} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (window.location.pathname === '/beatmanagement' ? 'active' : '')}>
            <img
              className="sideimagePng"
              src={Image_Url.BEAT_MAP}
              alt="ProfilesInfo"
            />
            <span>Beat Management</span>
          </div>
        </span> : ""}
      {Role.toLowerCase().trim() === role.superAdmin || permissions.includes("can_access_dbt_mapping") && is2w() ?
        <span onClick={onDbtRuleManagementclick} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (window.location.pathname === '/incentiveconfiguration' ? 'active' : '')}>
            <img
              className="sideimagePng"
              src={Image_Url.INCENTIVE_MAPPING}
              alt="ProfilesInfo"
            />
            <span>DBT Rules Management</span>
          </div>
        </span> : ""}

      {Role.toLowerCase().trim() === role.superAdmin || permissions.includes("upload_pincode_master") && is2w() ?
        <span onClick={onPincodeMasterListclick} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (window.location.pathname === '/pincodemasterlist' ? 'active' : '')}>
            <img
              className="sideimagePng"
              src={Image_Url.PINCODE_MASTER_LIST_ICON}
              alt="ProfilesInfo"
            />
            <span>Pincode Mapping Update</span>
          </div>
        </span> : ""}
      {/* {is3w() ? null : */}
      {(Role.toLowerCase().trim() === role.superAdmin || permissions.includes("target_vs_achievement")) && is2w() ?
        <span onClick={onTargetVSAchievementListclick} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (window.location.pathname === '/planvsactual' ? 'active' : '')}>
            <img
              className="sideimagePng"
              src={Image_Url.PLAN_VS_ACTUAL_ICON}
              alt="ProfilesInfo"
            />
            <span>Plan V/S Actual</span>
          </div>
        </span> : ""}
      {permissions.includes("can_access_msr") && is3w() ?
        <span onClick={onProductTrainingclick} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (window.location.pathname === '/training/tutorialtroubleshooting' ? 'active' : '')}>
            <img
              className="sideimage"
              src={Image_Url.PRODUCTTRAINING}
              alt="ProfilesInfo"
            />
            <span>Product Training</span>
          </div>
        </span> : ""}

      {permissions.includes("can_access_msr") && is2w() ?
        <span onClick={on2wProductTrainingclick} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (window.location.pathname === '/2w/training/list' ? 'active' : '')}>
            <img
              className="sideimage"
              src={Image_Url.PRODUCTTRAINING}
              alt="ProfilesInfo"
            />
            <span>Product Training</span>
          </div>
        </span> : ""}

      {permissions.includes("can_access_msr") && is3w() ?
        <span onClick={onReferralclick} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (window.location.pathname === '/3w/referral' ? 'active' : '')}>
            <img
              className="sideimage"
              src={Image_Url.REFFERAL}
              alt="ProfilesInfo"
            />
            <span>Referral</span>
          </div>
        </span> : ""}

      <div>
        <span onClick={handlesettingSubMenu} className="anchor_hyperlink">
          <div className={'SideBarbox ' + (isSubMenuOpen || window.location.pathname === '/setting/changepassword' || window.location.pathname === '/setting/dbtconfiguration' ? 'active' : '')} >
            <img
              className="sideimage"
              src={Image_Url.SETTING_ICON}
              alt="ProfilesInfo"
            />
            <span>Settings</span>
          </div>
        </span>
        {settingtoggler && (
          <ul>
            <span onClick={onsettingclick} className="anchor_hyperlink">
              <div className={'SideBarbox ' + (window.location.pathname === '/setting/changepassword' ? 'active' : '')} >
                <img
                  className="sideimage"
                  src={Image_Url.CHANGE_PASSWORD_ICON}
                  alt="ProfilesInfo"
                />
                <span className="manage_training_text">Change Password</span>
              </div>
            </span>
            {Role.toLowerCase().trim() === role.superAdmin || permissions.includes("can_access_dbt_mapping") && is2w() ?
              <span onClick={onDbtConfigurationClick} className="anchor_hyperlink">
                <div className={'SideBarbox ' + (window.location.pathname === '/setting/dbtconfiguration' ? 'active' : '')} >
                  <img
                    className="sideimagePng"
                    src={Image_Url.DBT_CONFIGURATION}
                    alt="DBT Configuration"
                  />
                  <span className="manage_training_text">DBT Configuration</span>
                </div>
              </span>
            : ""}
          </ul>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
